import React from "react";
import general from "../../../../../general";
import { useRedEnvelope } from "../redEnvelope/RedEnvelopeContext";

export default function TipMessage({ msg }) {
  const { getRedEnvelopeInfo, openRedEnvelopeAlert, handleRecord } = useRedEnvelope();
  if (!msg.body || typeof msg.body !== "string") return null;
  try {
    const trimmed = msg.body.trim().replace(/'/g, '"');
    const attach = JSON.parse(trimmed);
    return (
      <div className="imc-tip">
        <img src="resources/251222/re_small.png" alt="" className="imc-tip-icon" />
        <span className="imc-tip-text">{attach?.title}</span>
        <span
          className="imc-tip-action"
          onClick={() => {
            getRedEnvelopeInfo(attach?.redenvelope_id).then((data) => {
              if (data.is_pop_bullet) {
                openRedEnvelopeAlert(data);
              } else {
                general.history.push(`/redEnvelopeRecord?id=${data?.redenvelope_id}`);
              }
            });
          }}
        >
          红包
        </span>
      </div>
    );
  } catch (e) {
    return <div className="imc-tip">{msg.body}</div>;
  }
}
